export const OFFLINEFILES = "https://support.sheetgo.com/how-to-upload-or-sync-desktop-files-to-onedrive"
export const SHEETGOSUPPORT = "https://support.sheetgo.com"
export const GETHELPSIGNUP = "https://support.sheetgo.com/problems-signing-up-for-sheetgo-when-using-the-sheetgo-add-in-for-excel"
export const WHINEEDACCOUNT = "https://support.sheetgo.com/why-do-i-need-a-sheetgo-account-to-use-the-excel-add-in"
